import React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTournament } from "../contexts/TournamentContext";

const ArchiveLandingPage = () => {
  const navigate = useNavigate();
  const { label, basePath, venue, readOnly } = useTournament();

  const links = [
    { label: "Leaderboard", path: `${basePath}/leaderboard` },
    { label: "Live Scoring", path: `${basePath}/live-scoring` },
    { label: "Players", path: `${basePath}/players` },
    { label: "Pool", path: `${basePath}/golf-pool` },
  ];

  return (
    <Box bg="gray.900" minH="calc(100vh - 64px)">
      <Container maxW="container.md" py={16}>
        <VStack spacing={8} textAlign="center">
          <Badge colorScheme="blue" px={3} py={1} borderRadius="full">
            {readOnly ? "Archive" : "Current Season"}
          </Badge>
          <Heading size="2xl">{label} Results</Heading>
          <Text fontSize="lg" color="gray.300">
            {venue}
          </Text>
          {readOnly && (
            <Text fontSize="md" color="gray.400">
              View final scores, players, and pool results from last year.
            </Text>
          )}
          <VStack spacing={4} w="full" pt={4}>
            {links.map((link) => (
              <Button
                key={link.path}
                size="lg"
                w="full"
                maxW="sm"
                colorScheme="green"
                onClick={() => navigate(link.path)}
              >
                {link.label}
              </Button>
            ))}
          </VStack>
          {readOnly && (
            <HStack pt={6}>
              <Button variant="outline" colorScheme="white" onClick={() => navigate("/")}>
                Back to AR 2026
              </Button>
            </HStack>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default ArchiveLandingPage;
